/* src/app/admin/client/create-or-update-client.component.scss */
.action-bar {
  margin-bottom: 10px;
}
/*# sourceMappingURL=create-or-update-client.component-7R4S3QTY.css.map */
